import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'STUDENT_DEMO_LIST_GET_ALL',
  GET_ALL_SUCCESS: 'STUDENT_DEMO_LIST_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'STUDENT_DEMO_LIST_GET_ALL_FAILURE',

  POST: 'STUDENT_DEMO_POST',
  POST_SUCCESS: 'STUDENT_DEMO_POST_SUCCESS',
  POST_FAILURE: 'STUDENT_DEMO_POST_FAILURE',

  INVALIDATE_LIST: 'STUDENT_DEMO_LIST_INVALIDATE_ALL',
};

export const getAll = actions.getAll(
  (query, meta) => `${BASE_URL}/classroom/student-demos/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post((id, value) => `${BASE_URL}/classroom/student-demos/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const invalidateList = params => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_LIST,
    payload: { params },
  });
};
